import { useApiQuery } from '../../../api';
import { useBuildVars } from 'src/config';

export type AuditLogSearchQuery = {
  BidNumber?: string;
  Category?: string;
  EventType?: string[];
  FromDate?: string;
  ToDate?: string;
  User?: string;
  VendorId?: number;
  VendorProgramId?: number[];
};

export interface Pagination {
  pageNumber: number;
  pageSize: number;
}

export interface AuditSearchRequest extends Pagination {
  bidNumber?: string;
  category?: string;
  eventType?: string;
  fromDate?: string;
  toDate?: string;
  user?: string;
  vendorId?: number;
  vendorProgramId?: number[];
}

export interface AuditLogRow {
  auditId: number;
  beM_Number: string;
  bid_Number: string | null;
  category: string;
  dealId: number;
  eventType: string;
  modifiedBy: string;
  modifiedDate: string;
  totalCount: number;
  vendor_ID: number;
  vendor_Name: string | null;
  vendor_Program_ID: number;
  vendor_Program_Name: string | null;
}

export type AuditLogsResponse = {
  pageDetails: {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  };
  response: AuditLogRow[];
};

export interface AuditFilterResponse {
  auditEventList: string[];
  auditUserList: string[];
  bidList: string[];
  categoryFilter: string;
  categoryList: string[];
  cogUserList: string[];
  eventFilter: string;
  roleId: number;
}

export interface AuditFilterRequest {
  RoleId: number;
  bidFilter?: string;
  categoryFilter: string;
  eventFilter?: string;
}

export const buildAuditSearchRequest = (
  query: AuditLogSearchQuery,
  page: Pagination
): AuditSearchRequest => ({
  ...(query.BidNumber && { bidNumber: query.BidNumber }),
  ...(query.Category && { category: query.Category }),
  ...(query.EventType?.length && { eventType: query.EventType.join(',') }),
  ...(query.FromDate && { fromDate: query.FromDate }),
  ...(query.ToDate && { toDate: query.ToDate }),
  pageNumber: page.pageNumber,
  pageSize: page.pageSize,
  ...(query.User && { user: query.User }),
  ...(query.VendorId && { vendorId: query.VendorId }),
  ...(query.VendorProgramId && {
    vendorProgramId: query.VendorProgramId,
  }),
});

export function useGetAuditFilters(
  params: AuditFilterRequest,
  enabled?: boolean
) {
  const buildVars = useBuildVars();

  return useApiQuery<AuditFilterResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiAudit/auditeventlist',
    params,
    { enabled },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export function useGetGdsAuditLogs(
  query: AuditSearchRequest,
  enabled?: boolean
) {
  const buildVars = useBuildVars();

  return useApiQuery<AuditLogsResponse>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/SearchGDSAuditLogs',
    query,
    { enabled },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export interface Vendors {
  vendorID: number;
  vendorName: string;
}

export function useGetAuditLogVendorList(enabled?: boolean) {
  const buildVars = useBuildVars();
  return useApiQuery<Vendors[]>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorlist',
    undefined,
    { enabled },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
